export enum NotificationOriginEnum {
  SYSTEM,
  UPLOAD_HUB,
  DATA_SOURCE,
  INTERNAL,
}
